import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileHorizontalSeparatorControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        element.parent().css("width","100%");
        element.css({"width":"100%", "height": ""});
        element.find("div:first").css("width","100%");
    }
}

const mobileHorizontalSeparatorControlView = new MobileHorizontalSeparatorControlView();
export default mobileHorizontalSeparatorControlView;